module.exports = __webpack_public_path__ + "static/img/contact_logo1.e4a5083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo1.png
// module id = aEiA
// module chunks = 1